"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DiagnosticTools() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  return <section data-section-id="1999" id="diagnostic-tools" className="dark bg-background py-20 px-4 sm:px-6 lg:py-28">
      <div className="mx-auto max-w-3xl">
        <div ref={ref} className={`relative overflow-hidden rounded-lg border border-border px-6 py-16 sm:px-12 sm:py-20 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        backgroundImage: "linear-gradient(135deg, hsl(225 73% 20% / 0.05), hsl(217 91% 60% / 0.05))"
      }}>
          {}
          <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center">
            <svg viewBox="0 0 64 64" fill="none" stroke="var(--chart-2)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="h-16 w-16" aria-hidden="true">
              <path d="M14 44c0-6 4-10 10-10h16c6 0 10 4 10 10" />
              <path d="M24 34V20" />
              <path d="M32 34V16" />
              <path d="M40 34V21" />
              <path d="M24 20c-3-2-4-5-4-8" />
              <path d="M32 16c0-4 2-7 5-9" />
              <path d="M40 21c2-2 5-3 8-3" />
            </svg>
          </div>

          <h2 className="font-default font-semibold text-4xl sm:text-5xl text-foreground tracking-tight">
            Assess Your Potential
          </h2>

          <p className="mx-auto mt-6 max-w-xl font-default text-base sm:text-lg leading-relaxed text-muted-foreground">
            Precision is the foundation of academic mastery. Download our 10-question diagnostic practice test to identify your current baseline and begin your path toward peak performance.
          </p>

          <div className="mt-10 flex justify-center">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-lg bg-primary text-primary-foreground px-8 py-6 text-base transition-all duration-500 ease-out hover:-translate-y-1 hover:bg-primary/90 hover:shadow-lg">
              <Link to="/ResourcesPage">Download Diagnostic Test</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}